module.exports = __webpack_public_path__ + "static/media/XT.bcb7662f.png";